/**
 * GlassesUSA-style Transitions type + color drawer.
 * Keeps LensAdvizor's native data/submit APIs, while combining type and color.
 */
(function () {
  var STEP_SELECTOR = '.la-choose-prescription-wrapper.la-render-lenses:not(.x-pro)';
  var SCOPE_CLASS = 'ciw-la-transitions-drawer-step';
  var BODY_CLASS = 'ciw-la-transitions-drawer-active';
  var SKIP_CLASS = 'ciw-la-transitions-drawer-skipping';
  var FORWARD_USED_CLASS = 'ciw-la-transitions-drawer-forward-used';
  var PICKED_CLASS = 'ciw-la-lens-card--picked';
  var SWATCH_CLASS = 'ciw-la-transitions-drawer__swatch';
  var SWATCH_PICKED_CLASS = 'is-picked';
  var STEP_TITLE = 'Choose transition type';
  var BACKDROP_CLASS = 'ciw-la-transitions-drawer__backdrop';
  var MOBILE_SHEET_CLASS = 'ciw-la-transitions-drawer-mobile-sheet';
  var RESUMING_CLASS = 'ciw-la-transitions-drawer-resuming';
  var SHEET_HEADER_CLASS = 'ciw-la-transitions-drawer__sheet-header';
  var DRAG_ZONE_CLASS = 'ciw-la-transitions-drawer__drag-zone';
  var HANDLE_CLASS = 'ciw-la-transitions-drawer__handle';
  var TITLE_ROW_CLASS = 'ciw-la-transitions-drawer__title-row';
  var SHEET_TITLE_CLASS = 'ciw-la-transitions-drawer__title';
  var SHEET_CLOSE_CLASS = 'ciw-la-transitions-drawer__close';
  var PREVIEW_CLASS = 'ciw-la-transitions-drawer__preview';
  var PREVIEW_IMAGE_CLASS = 'ciw-la-transitions-drawer__preview-image';
  var PREVIEW_VISIBLE_CLASS = 'is-visible';
  var DRAGGING_CLASS = 'ciw-la-transitions-drawer-dragging';
  var DISMISSING_CLASS = 'ciw-la-transitions-drawer-dismissing';
  var DISMISS_THRESHOLD_PX = 88;
  var DISMISS_VELOCITY = 0.55;

  var scope = null;
  var pendingWrapper = null;
  var pendingColor = '';
  var confirming = false;
  var skippingBack = false;
  var scanQueued = false;
  var moScanQueued = false;
  var lastDrawerCardRefresh = 0;
  var drawerPlaceholder = null;
  var drawerMountedRoot = null;
  var drawerConfirmedForward = false;
  var dragState = null;
  var dismissing = false;
  var skipRestoreOnNextActivate = false;
  var skipRestoreUntil = 0;
  var freshDrawerEntry = false;
  var usedDrawerForward = false;
  var skipBackQueued = false;
  var programmaticBackNavigation = false;
  var TAP_MOVE_THRESHOLD_PX = 15;
  var SWATCH_SCROLL_THRESHOLD_PX = 2;
  var pointerGesture = null;
  var lastPointerPickAt = 0;

  function getEventElement(target) {
    if (!target) return null;
    if (target.nodeType === 1) return target;
    return target.parentElement || null;
  }

  function norm(value) {
    return String(value || '').replace(/\s+/g, ' ').trim();
  }

  function isVisible(el) {
    if (!el || el.hidden) return false;
    var style = window.getComputedStyle(el);
    return style.display !== 'none' && style.visibility !== 'hidden' && el.getClientRects().length > 0;
  }

  function getTitle(wrapper) {
    var title = wrapper && wrapper.querySelector('.la-label-title');
    return norm(title ? title.textContent : '');
  }

  function getButton(wrapper) {
    return wrapper && wrapper.querySelector('.la-label-btn');
  }

  function getRadio(wrapper) {
    return wrapper && wrapper.querySelector('input[type="radio"].la-tap-select');
  }

  function isGenS(name) {
    return /gen\s*s/i.test(norm(name)) && !/xtr\s*active|xtractive/i.test(norm(name));
  }

  function isXtr(name) {
    return /xtr\s*active|xtractive/i.test(norm(name)) && !/polari[sz]ed/i.test(norm(name));
  }

  function isPhotocromic(name) {
    var label = norm(name);
    if (!label || isGenS(label) || isXtr(label)) return false;
    return /^photocromic\b|^photochromic\b/i.test(label);
  }

  function isOfferedType(name) {
    return isGenS(name) || isXtr(name);
  }

  function isDrawerType(name) {
    return isOfferedType(name) || isPhotocromic(name);
  }

  function isExcludedType(name) {
    return /polari[sz]ed/i.test(norm(name));
  }

  function getWrappers(root) {
    root = root || scope;
    if (!root) return [];
    var seen = {};
    var out = [];
    Array.prototype.forEach.call(root.children, function (el) {
      if (!el.classList || !el.classList.contains('la-label-btn-wrapper')) return;
      var key = getTitle(el).toLowerCase();
      if (!key || seen[key]) return;
      seen[key] = true;
      out.push(el);
    });
    if (out.length) return out;
    Array.prototype.forEach.call(root.querySelectorAll('.la-label-btn-wrapper'), function (el) {
      var key = getTitle(el).toLowerCase();
      if (!key || seen[key]) return;
      seen[key] = true;
      out.push(el);
    });
    return out;
  }

  function isTransitionsTypeScope(root) {
    if (!root || !root.classList.contains('la-render-lenses') || root.classList.contains('x-pro')) {
      return false;
    }
    var offered = 0;
    getWrappers(root).forEach(function (wrapper) {
      if (isOfferedType(getTitle(wrapper))) offered++;
    });
    return offered === 2;
  }

  function isNonTransitionsLensGroupTitle(title) {
    return /sunglass|blue\s*light|clear(?:\s+lens)?|standard\s+lens/i.test(norm(title));
  }

  function isTransitionsGroupTitle(title) {
    var label = norm(title);
    if (!label || isNonTransitionsLensGroupTitle(label)) return false;
    return /\btransitions?\b|photochromic|xtr\s*active|xtractive/i.test(label);
  }

  function getCheckedLensGroupLabel(root) {
    root = root || document;
    var checked = root.querySelector(
      '#lensadvizor-prescription-modal .la-render-lenses.x-pro input[type="radio"].la-tap-select:checked, .la-render-lenses.x-pro input[type="radio"].la-tap-select:checked'
    );
    if (!checked) return '';
    var btn = checked.closest('.la-label-btn');
    var titleNode = btn && btn.querySelector('.la-label-title');
    return norm(titleNode ? titleNode.textContent : checked.value || '');
  }

  function isTransitionsLensFlowFromLa(la) {
    la = la || window.LensAdvizor;
    if (!la || !la.response) return false;

    if (la.lensGroups && la.response.lensGroupSelected) {
      var selectedKey = la.response.lensGroupSelected;
      var i;
      for (i = 0; i < la.lensGroups.length; i++) {
        var group = la.lensGroups[i];
        if (group.group_type !== selectedKey && String(group.id) !== String(selectedKey)) {
          continue;
        }
        if (isTransitionsGroupTitle(group.group_title || group.title || '')) return true;
      }
    }

    var lens = la.response.lens;
    if (lens) {
      if (isTransitionsGroupTitle(lens.group_title || '') || isTransitionsGroupTitle(lens.group_type || '')) {
        return true;
      }
      if (isOfferedType(lens.name) || isPhotocromic(lens.name)) return true;
    }

    return false;
  }

  function isSunglassesLensFlowActive() {
    if (document.body.classList.contains('ciw-la-sunglasses-lens-selection-active')) return true;

    var sunglassesStep = document.querySelector(
      '.la-choose-prescription-wrapper.ciw-la-sunglasses-lens-selection-step'
    );
    if (sunglassesStep && isVisible(sunglassesStep)) return true;

    return /sunglass/i.test(getCheckedLensGroupLabel());
  }

  function isTransitionsLensFlow() {
    if (isSunglassesLensFlowActive()) return false;
    if (document.body.classList.contains(BODY_CLASS)) return true;
    if (isTransitionsLensFlowFromLa()) return true;
    return isTransitionsGroupTitle(getCheckedLensGroupLabel());
  }

  function isLensPackageOptionsStep(options) {
    if (!options) return false;
    if (options.classList.contains('ciw-la-lens-package-step')) return true;

    var titleEl =
      options.querySelector('#la_prescriptionSelect_title') ||
      options.querySelector('.la-wrapper-heading h3');
    if (/choose\s+lens\s+package/i.test(norm(titleEl && titleEl.textContent))) return true;

    var tierCount = 0;
    options.querySelectorAll('.la-label-btn-wrapper').forEach(function (wrapper) {
      var title = getTitle(wrapper).toLowerCase();
      if (/^(basic|standard|polycarbonate|premium|supreme\+?)$/.test(title)) tierCount++;
    });
    return tierCount >= 2;
  }

  function isProgressiveTypeScopeByCards(scope, opts) {
    opts = opts || {};
    if (!scope || scope.hidden) return false;
    if (!opts.ignoreVisibility && !isVisible(scope)) return false;
    if (scope.classList.contains('ciw-la-lens-package-step')) return false;
    if (scope.classList.contains('ciw-la-lens-thickness-step')) return false;
    if (isLensPackageOptionsStep(scope)) return false;

    var wrappers = scope.querySelectorAll('.la-label-btn-wrapper');
    if (wrappers.length < 3) return false;

    var tierCount = 0;
    var colorCount = 0;
    var i;
    for (i = 0; i < wrappers.length; i++) {
      var title = getTitle(wrappers[i]).toLowerCase();
      if (/^(basic|standard|polycarbonate|premium|supreme\+?)$/.test(title)) tierCount++;
      else if (
        /^(brown|gray|grey|green|blue|amber|graphite|amethyst|ruby|emerald|sapphire)$/.test(title)
      ) {
        colorCount++;
      }
    }
    return tierCount === 0 && colorCount === 0;
  }

  function findProgressiveTypeScopeByCards(opts) {
    var scopes = document.querySelectorAll('.la-choose-prescription-wrapper.la-render-options');
    var i;
    for (i = 0; i < scopes.length; i++) {
      if (isProgressiveTypeScopeByCards(scopes[i], opts)) return scopes[i];
    }
    return null;
  }

  function landOnDownstreamStepAfterBack() {
    [0, 80, 200, 400, 700, 1000, 1200].forEach(function (delay) {
      window.setTimeout(function () {
        clearSkipForVisibleDownstreamStep();
      }, delay);
    });
  }

  function clearSkipForVisibleDownstreamStep() {
    if (document.body.classList.contains(BODY_CLASS)) return;

    var title = getActiveStepTitle();
    var onDownstreamTitle =
      /choose lens package|available upgrade|review your selection|progressive type|lens thickness|lens index/i.test(
        title
      );

    var visibleSelectors = [
      '.la-choose-prescription-wrapper.ciw-la-lens-package-step',
      '.la-choose-prescription-wrapper.ciw-la-progressive-type-options-step',
      '.la-choose-prescription-wrapper.la-render-addons',
      '.la-choose-prescription-wrapper.la-render-review'
    ];
    var hasVisibleDownstream = onDownstreamTitle;
    var i;
    if (!hasVisibleDownstream) {
      for (i = 0; i < visibleSelectors.length; i++) {
        var el = document.querySelector(visibleSelectors[i]);
        if (el && isVisible(el)) {
          hasVisibleDownstream = true;
          break;
        }
      }
    }

    if (!hasVisibleDownstream) return;

    document.body.classList.remove(SKIP_CLASS);
    document.body.classList.remove(FORWARD_USED_CLASS);
    tagProgressiveTypeScopeIfNeeded();
    restoreVisibleLensPackageSteps();
    document.dispatchEvent(new CustomEvent('ciw-la-transitions-drawer:changed'));
    document.dispatchEvent(new CustomEvent('ciw-la-lens-package:continue-sync'));
  }

  function shouldArmSkipOnBackPointerdown() {
    if (!shouldReopenDrawerOnBack()) return false;
    var title = getActiveStepTitle();
    if (/review your selection|available upgrade|choose lens package/i.test(title)) return false;
    if (isProgressiveTypeStepActive()) return false;
    return isNativeColorStepActive() || /select.*color/i.test(title);
  }

  function revealRetiredStep(el) {
    if (!el) return;
    el.classList.remove('ciw-la-transitions-drawer__step-retired');
    el.hidden = false;
    el.removeAttribute('aria-hidden');
  }

  function restoreRetiredPackageOptionSteps() {
    document
      .querySelectorAll(
        '#lensadvizor-prescription-modal .la-choose-prescription-wrapper.la-render-options'
      )
      .forEach(function (options) {
        if (!isRetiredTransitionStep(options)) return;
        if (!isLensPackageOptionsStep(options)) return;
        revealRetiredStep(options);
      });
  }

  function restoreWronglyRetiredLensPackageSteps() {
    if (!/choose\s+lens\s+package/i.test(getActiveStepTitle())) return;
    getTransitionTypeRoots().forEach(function (el) {
      if (!isRetiredTransitionStep(el)) return;
      if (isTransitionsTypeScope(el)) return;
      revealRetiredStep(el);
    });
  }

  function clearTransitionsFlowPollution() {
    restoreRetiredPackageOptionSteps();
    restoreWronglyRetiredLensPackageSteps();

    if (isTransitionsLensFlow()) return;

    confirming = false;
    drawerConfirmedForward = false;
    usedDrawerForward = false;
    skipBackQueued = false;
    skippingBack = false;
    document.body.classList.remove(FORWARD_USED_CLASS);
    document.body.classList.remove(SKIP_CLASS);
  }

  function tagProgressiveTypeScopeIfNeeded(opts) {
    opts = opts || {};
    var findOpts = opts.ignoreVisibility || confirming ? { ignoreVisibility: true } : null;
    var scope = findProgressiveTypeScopeByCards(findOpts);
    if (!scope) {
      var title = getActiveStepTitle();
      if (!/choose\s+progressive\s+type|progressive\s+type/i.test(title)) return null;
      var scopes = document.querySelectorAll('.la-choose-prescription-wrapper.la-render-options');
      var i;
      for (i = 0; i < scopes.length; i++) {
        if (scopes[i].classList.contains('ciw-la-lens-package-step')) continue;
        if (scopes[i].classList.contains('ciw-la-lens-thickness-step')) continue;
        if (!findOpts && !isVisible(scopes[i])) continue;
        scope = scopes[i];
        break;
      }
    }
    if (!scope) return null;
    scope.classList.add('ciw-la-progressive-type-options-step');
    document.body.classList.remove(SKIP_CLASS);
    document.body.classList.remove(FORWARD_USED_CLASS);
    document.dispatchEvent(new CustomEvent('ciw-la-progressive-type:layout', { detail: { root: document } }));
    document.dispatchEvent(new CustomEvent('ciw-la-lens-package:scan-now', { detail: { root: document } }));
    document.dispatchEvent(new CustomEvent('ciw-la-lens-package:continue-sync'));
    document.dispatchEvent(new CustomEvent('ciw-la-transitions-drawer:changed'));
    return scope;
  }

  function releaseProgressiveTypeDuringConfirm() {
    if (!confirming || !drawerConfirmedForward || !isProgressiveTransitionsFlow()) return false;
    hideNativeColorStep();
    if (!findProgressiveTypeScopeByCards({ ignoreVisibility: true })) return false;
    tagProgressiveTypeScopeIfNeeded({ ignoreVisibility: true });
    if (isConfirmAdvanceComplete()) finishConfirm();
    return true;
  }

  function startProgressiveTypeReleaseBurst() {
    var started = Date.now();
    var tick = function () {
      releaseProgressiveTypeDuringConfirm();
      if (!confirming || Date.now() - started > 4000) return;
      window.setTimeout(tick, 16);
    };
    tick();
  }

  function findLensPackageScopeByCards() {
    var scopes = document.querySelectorAll('.la-choose-prescription-wrapper.la-render-options');
    var i;
    for (i = 0; i < scopes.length; i++) {
      if (!isVisible(scopes[i])) continue;
      if (isLensPackageOptionsStep(scopes[i])) return scopes[i];
    }
    return null;
  }

  function tagLensPackageScopeIfNeeded() {
    var scope = findLensPackageScopeByCards();
    if (!scope && /choose\s+lens\s+package/i.test(getActiveStepTitle())) {
      var scopes = document.querySelectorAll('.la-choose-prescription-wrapper.la-render-options');
      var i;
      for (i = 0; i < scopes.length; i++) {
        if (!isVisible(scopes[i])) continue;
        if (scopes[i].classList.contains('ciw-la-progressive-type-options-step')) continue;
        if (isLensPackageOptionsStep(scopes[i])) {
          scope = scopes[i];
          break;
        }
      }
    }
    if (!scope) return null;
    scope.classList.add('ciw-la-lens-package-step');
    document.body.classList.remove(SKIP_CLASS);
    document.body.classList.remove(FORWARD_USED_CLASS);
    restoreVisibleLensPackageSteps();
    document.dispatchEvent(new CustomEvent('ciw-la-lens-package:scan-now', { detail: { root: document } }));
    document.dispatchEvent(new CustomEvent('ciw-la-lens-package:continue-sync'));
    document.dispatchEvent(new CustomEvent('ciw-la-transitions-drawer:changed'));
    return scope;
  }

  function prepProgressiveTypeToPackageTransition() {
    if (!isProgressiveTransitionsFlow()) return;
    document.body.classList.remove(SKIP_CLASS);
    document.body.classList.remove(FORWARD_USED_CLASS);
    hideNativeColorStep();
    restoreVisibleLensPackageSteps();
  }

  function handleLensOptionsRenderedDuringFlow() {
    if (!isProgressiveTransitionsFlow()) return;

    if (confirming && drawerConfirmedForward) {
      hideNativeColorStep();
      if (findProgressiveTypeScopeByCards({ ignoreVisibility: true })) {
        tagProgressiveTypeScopeIfNeeded({ ignoreVisibility: true });
        finishConfirm();
        return;
      }
      if (isConfirmAdvanceComplete()) {
        finishConfirm();
      }
      return;
    }

    if (tagLensPackageScopeIfNeeded()) return;
    tagProgressiveTypeScopeIfNeeded();
  }

  function isDownstreamStepVisible() {
    if (confirming) return false;

    var modalTitle = document.querySelector(
      '#lensadvizor-prescription-modal #la_prescriptionSelect_title, #lensadvizor-prescription-modal .la-wrapper-heading h3'
    );
    var titleText = norm(modalTitle && modalTitle.textContent);
    if (
      /choose lens package|available upgrade|review your selection|lens thickness|lens index|progressive type/i.test(
        titleText
      )
    ) {
      return true;
    }

    if (drawerConfirmedForward && /select.*color/i.test(titleText)) {
      return true;
    }

    var downstreamSelectors = [
      '.la-choose-prescription-wrapper.ciw-la-lens-package-step',
      '.la-choose-prescription-wrapper.la-render-options.ciw-la-lens-package-step',
      '.la-choose-prescription-wrapper.ciw-la-progressive-type-options-step',
      '.la-choose-prescription-wrapper.ciw-la-lens-thickness-step',
      '.la-choose-prescription-wrapper.la-render-addons',
      '.la-choose-prescription-wrapper.la-render-review'
    ];
    var i;
    for (i = 0; i < downstreamSelectors.length; i++) {
      var step = document.querySelector(downstreamSelectors[i]);
      if (step && isVisible(step)) return true;
    }

    var options = document.querySelector('.la-choose-prescription-wrapper.la-render-options');
    if (options && isVisible(options)) {
      var title =
        options.querySelector('#la_prescriptionSelect_title') ||
        options.querySelector('.la-wrapper-heading h3');
      var optionsTitle = norm(title && title.textContent);
      if (/package|upgrade|thickness|index|review/i.test(optionsTitle)) return true;
      if (!/select.*color/i.test(optionsTitle)) return true;
    }

    return false;
  }

  function getTransitionTypeRoots() {
    return document.querySelectorAll(
      '#lensadvizor-prescription-modal .la-choose-prescription-wrapper.la-render-lenses:not(.x-pro)'
    );
  }

  function isRetiredTransitionStep(root) {
    return !!(root && (root.hidden || root.classList.contains('ciw-la-transitions-drawer__step-retired')));
  }

  function findTransitionDrawerRoot() {
    var roots = getTransitionTypeRoots();
    var i;
    var fallback = null;
    for (i = 0; i < roots.length; i++) {
      if (!isTransitionsTypeScope(roots[i])) continue;
      if (!isRetiredTransitionStep(roots[i]) && isVisible(roots[i])) return roots[i];
      if (!fallback) fallback = roots[i];
    }
    return fallback;
  }

  function ensureTransitionDrawerRoot() {
    var roots = getTransitionTypeRoots();
    var i;
    var picked = null;
    for (i = 0; i < roots.length; i++) {
      if (!isTransitionsTypeScope(roots[i])) continue;
      revealTransitionTypeStep(roots[i]);
      if (!picked) picked = roots[i];
    }
    return picked;
  }

  function hideNativeColorStep() {
    if (!isTransitionsLensFlow()) return;

    var options = document.querySelector('.la-choose-prescription-wrapper.la-render-options');
    if (!options || options.classList.contains('ciw-la-lens-package-step')) return;
    if (options.classList.contains('ciw-la-progressive-type-options-step')) return;
    if (isLensPackageOptionsStep(options)) return;
    var optionsTitleEl =
      options.querySelector('#la_prescriptionSelect_title') ||
      options.querySelector('.la-wrapper-heading h3');
    if (/progressive\s+type/i.test(norm(optionsTitleEl && optionsTitleEl.textContent))) return;
    options.classList.add('ciw-la-transitions-drawer__step-retired');
    options.hidden = true;
    options.setAttribute('aria-hidden', 'true');
  }

  function canResumeDrawerAfterForward() {
    return usedDrawerForward || document.body.classList.contains(FORWARD_USED_CLASS);
  }

  function isProgressiveTypeStepActive() {
    if (findProgressiveTypeScopeByCards()) return true;
    var title = getActiveStepTitle();
    if (/choose\s+progressive\s+type|progressive\s+type/i.test(title)) return true;
    var step = document.querySelector(
      '.la-choose-prescription-wrapper.ciw-la-progressive-type-options-step'
    );
    return !!(step && isVisible(step));
  }

  function reopenDrawerFromForwardBack() {
    if (reopenDrawerFromForwardBack._busy) return false;
    var root = ensureTransitionDrawerRoot() || findTransitionDrawerRoot();
    if (!root) return false;

    reopenDrawerFromForwardBack._busy = true;
    armSkipNativeColorStep();
    hideNativeColorStep();
    hideStaleTransitionTypeSteps(root);
    revealTransitionTypeStep(root);
    skipRestoreOnNextActivate = false;
    activate(root);
    restoreSelectionFromLa();
    syncSelection();
    window.setTimeout(function () {
      document.body.classList.remove(SKIP_CLASS);
      reopenDrawerFromForwardBack._busy = false;
      document.dispatchEvent(new CustomEvent('ciw-la-lens-package:continue-sync'));
      scheduleScan();
    }, 120);
    return true;
  }

  function shouldReopenDrawerOnBack() {
    if (!isTransitionsLensFlow()) return false;
    if (!canResumeDrawerAfterForward()) return false;
    if (document.body.classList.contains(BODY_CLASS)) return false;
    var title = getActiveStepTitle();
    if (isNativeColorStepActive()) return true;
    if (isProgressiveTypeStepActive()) return true;
    return /choose lens package|available upgrade|lens thickness|lens index|review your selection/i.test(
      title
    );
  }

  function getScope() {
    if (isDownstreamStepVisible()) return null;
    if (usedDrawerForward && isNativeColorStepActive()) return null;

    var modalTitle = document.querySelector(
      '#lensadvizor-prescription-modal #la_prescriptionSelect_title, #lensadvizor-prescription-modal .la-wrapper-heading h3'
    );
    if (/^lens type$/i.test(norm(modalTitle && modalTitle.textContent))) return null;

    var lensType = document.querySelector('.la-choose-prescription-wrapper.la-render-lenses.x-pro');
    if (lensType && isVisible(lensType)) return null;

    var roots = getTransitionTypeRoots();
    var i;
    var candidate = null;

    for (i = 0; i < roots.length; i++) {
      if (isRetiredTransitionStep(roots[i])) continue;
      if (isVisible(roots[i]) && isTransitionsTypeScope(roots[i])) return roots[i];
      if (!candidate && isTransitionsTypeScope(roots[i])) candidate = roots[i];
    }

    if (candidate) {
      revealTransitionTypeStep(candidate);
      if (isVisible(candidate) && isTransitionsTypeScope(candidate)) return candidate;
    }

    return null;
  }

  function getLensObjects() {
    var la = window.LensAdvizor;
    var found = [];
    var seen = {};
    if (!la) return found;

    function add(lens) {
      if (!lens || !isOfferedType(lens.name) || seen[lens.id || lens.name]) return;
      seen[lens.id || lens.name] = true;
      found.push(lens);
    }

    Object.keys(la.lensesByGroups || {}).forEach(function (key) {
      (la.lensesByGroups[key] || []).forEach(add);
    });
    (la.lenses || []).forEach(add);
    return found;
  }

  function getLensObject(typeName) {
    var targetIsGenS = isGenS(typeName);
    var targetIsXtr = isXtr(typeName);
    var lenses = getLensObjects();
    for (var i = 0; i < lenses.length; i++) {
      if ((targetIsGenS && isGenS(lenses[i].name)) || (targetIsXtr && isXtr(lenses[i].name))) {
        return lenses[i];
      }
    }
    return null;
  }

  function getColorValuesFromLens(lens) {
    if (!lens || !lens.options) return [];
    var keys = ['option1', 'option2', 'option3'];
    var i;
    for (i = 0; i < keys.length; i++) {
      var opt = lens.options[keys[i]];
      if (!opt || !Array.isArray(opt.values) || !opt.values.length) continue;
      var name = norm(opt.name).toLowerCase();
      if (/thickness|material|index|package|upgrade/.test(name) && !/color|tint/.test(name)) {
        continue;
      }
      if (/color|tint|photo\s*c?r?omic|transition/.test(name)) {
        return opt.values.map(norm).filter(Boolean);
      }
    }
    for (i = 0; i < keys.length; i++) {
      var fallbackOpt = lens.options[keys[i]];
      if (!fallbackOpt || !Array.isArray(fallbackOpt.values) || !fallbackOpt.values.length) continue;
      if (fallbackOpt.values.every(isLikelyLensColorName)) {
        return fallbackOpt.values.map(norm).filter(Boolean);
      }
    }
    return [];
  }

  function isLikelyLensColorName(value) {
    return /^(gray|grey|brown|g[\s.-]?15(\s+green)?|sapphire|ruby|amethyst|emerald|amber)$/i.test(
      norm(value)
    );
  }

  function getAllPhotocromicLenses() {
    var la = window.LensAdvizor;
    if (!la) return [];
    var out = [];
    var seen = {};

    function add(lens) {
      if (!lens || !isPhotocromic(lens.name) || seen[lens.id || lens.name]) return;
      seen[lens.id || lens.name] = true;
      out.push(lens);
    }

    Object.keys(la.lensesByGroups || {}).forEach(function (key) {
      (la.lensesByGroups[key] || []).forEach(add);
    });
    (la.lenses || []).forEach(add);
    return out;
  }

  function getPhotocromicLensObject() {
    var la = window.LensAdvizor;
    if (!la) return null;
    var lenses = la.lenses || [];
    var i;
    for (i = 0; i < lenses.length; i++) {
      if (isPhotocromic(lenses[i].name)) return lenses[i];
    }
    if (la.response && la.response.lens && isPhotocromic(la.response.lens.name)) {
      return la.response.lens;
    }
    return null;
  }

  function getLensObjectForType(typeName) {
    if (isPhotocromic(typeName)) return getPhotocromicLensObject();
    return getLensObject(typeName);
  }

  function getColors(typeName) {
    var lens = getLensObjectForType(typeName);
    var values = getColorValuesFromLens(lens);
    if (values.length) return values;
    if (!isPhotocromic(typeName)) return [];

    var altLenses = getAllPhotocromicLenses();
    var i;
    for (i = 0; i < altLenses.length; i++) {
      values = getColorValuesFromLens(altLenses[i]);
      if (values.length) return values;
    }
    return ['Gray', 'Brown'];
  }

  function colorValue(name) {
    var label = norm(name).toLowerCase();
    if (/gr[ae]y|graphite/.test(label)) return '#70747b';
    if (/brown/.test(label)) return '#7b5238';
    if (/g[\s.-]?15|green/.test(label)) return '#4c6650';
    if (/sapphire/.test(label)) return '#2868a7';
    if (/ruby/.test(label)) return '#a53643';
    if (/amethyst/.test(label)) return '#77568f';
    if (/emerald/.test(label)) return '#2f785d';
    if (/amber/.test(label)) return '#ad722c';
    return '#8d939b';
  }

  function displayColor(name) {
    return /^g[\s.-]?15(\s+green)?$/i.test(norm(name)) ? 'G15' : norm(name);
  }

  function getColorPreviewKey(color) {
    var label = norm(color).toLowerCase();
    if (/^gr[ae]y$/.test(label)) return 'gray';
    if (/^brown$/.test(label)) return 'brown';
    if (/^g[\s.-]?15(\s+green)?$/.test(label) || /graphite\s*green/.test(label)) return 'g15';
    if (/^sapphire$/.test(label)) return 'sapphire';
    if (/^ruby$/.test(label)) return 'ruby';
    if (/^amethyst$/.test(label)) return 'amethyst';
    if (/^emerald$/.test(label)) return 'emerald';
    if (/^amber$/.test(label)) return 'amber';
    return '';
  }

  function getColorPreviewUrl(color) {
    var key = getColorPreviewKey(color);
    if (!key) return '';
    var assets = window.ciwLaTransitionsPreviewAssets || {};
    return assets[key] || '';
  }

  function getColorPreviewHost(root) {
    if (!root) return null;
    if (isMobileViewport()) return root;
    return root.querySelector('.la-wrapper-heading') || root;
  }

  function ensureColorPreview(root) {
    if (!root) return null;
    var host = getColorPreviewHost(root);
    if (!host) return null;

    var preview = root.querySelector('.' + PREVIEW_CLASS);
    if (!preview) {
      preview = document.createElement('div');
      preview.className = PREVIEW_CLASS;
      preview.innerHTML =
        '<img class="' +
        PREVIEW_IMAGE_CLASS +
        '" alt="" loading="lazy" decoding="async" />';
      if (isMobileViewport()) {
        var mobileHeader = root.querySelector('.' + SHEET_HEADER_CLASS);
        if (mobileHeader && mobileHeader.nextSibling) {
          root.insertBefore(preview, mobileHeader.nextSibling);
        } else {
          root.appendChild(preview);
        }
      } else if (host.nextSibling) {
        host.parentNode.insertBefore(preview, host.nextSibling);
      } else {
        host.parentNode.appendChild(preview);
      }
    } else if (isMobileViewport()) {
      var header = root.querySelector('.' + SHEET_HEADER_CLASS);
      if (header && (preview.parentNode !== root || preview.previousSibling !== header)) {
        root.insertBefore(preview, header.nextSibling);
      }
    }

    return preview;
  }

  function syncColorPreview(root) {
    root = root || scope;
    if (!root) return;

    var preview = ensureColorPreview(root);
    if (!preview) return;

    var url = pendingColor ? getColorPreviewUrl(pendingColor) : '';
    var img = preview.querySelector('.' + PREVIEW_IMAGE_CLASS);
    var show = !!url;

    preview.classList.toggle(PREVIEW_VISIBLE_CLASS, show);
    preview.setAttribute('aria-hidden', show ? 'false' : 'true');

    if (!show) {
      if (img) {
        img.removeAttribute('src');
        img.alt = '';
      }
      return;
    }

    if (img && img.getAttribute('src') !== url) {
      img.src = url;
      img.alt =
        displayColor(pendingColor) +
        ' Transitions color preview from clear to dark';
    }
  }

  function getDefaultColorForType(typeName) {
    var colors = getColors(typeName);
    var i;
    for (i = 0; i < colors.length; i++) {
      if (/^gr[ae]y$/i.test(norm(colors[i]))) return colors[i];
    }
    return colors.length ? colors[0] : '';
  }

  function colorsMatch(a, b) {
    return norm(a).toLowerCase() === norm(b).toLowerCase();
  }

  function getBasicTierName(lens) {
    var opt2 = lens && lens.options && lens.options.option2;
    if (!opt2 || !Array.isArray(opt2.values) || !opt2.values.length) return 'Basic';
    var i;
    for (i = 0; i < opt2.values.length; i++) {
      if (/^basic$/i.test(norm(opt2.values[i]))) return norm(opt2.values[i]);
    }
    return norm(opt2.values[0]);
  }

  function getColorSurchargeFromRawOptions(lens, colorName) {
    if (!lens || !Array.isArray(lens.raw_options)) return 0;
    var target = norm(colorName).toLowerCase();
    var i;
    for (i = 0; i < lens.raw_options.length; i++) {
      var opt = lens.raw_options[i];
      if (!opt || !/color|tint|transition|photo/i.test(norm(opt.name))) continue;
      if (!Array.isArray(opt.values)) continue;
      var j;
      for (j = 0; j < opt.values.length; j++) {
        var val = opt.values[j];
        if (val && norm(val.name).toLowerCase() === target) {
          return parseFloat(val.price) || 0;
        }
      }
    }
    return 0;
  }

  function getDrawerVariantPrice(typeName, colorName) {
    var lens = getLensObjectForType(typeName);
    if (!lens || !colorName) return null;

    var basicTier = getBasicTierName(lens);
    var targetColor = norm(colorName).toLowerCase();
    var variants = lens.variants || [];
    var i;

    for (i = 0; i < variants.length; i++) {
      var variant = variants[i];
      if (
        colorsMatch(variant.option1, targetColor) &&
        norm(variant.option2) === basicTier
      ) {
        var variantPrice = parseFloat(variant.price);
        if (!isNaN(variantPrice)) return variantPrice;
      }
    }

    var base = parseFloat(lens.lens_base_price != null ? lens.lens_base_price : lens.price);
    if (isNaN(base)) return null;
    return base + getColorSurchargeFromRawOptions(lens, colorName);
  }

  function formatDrawerPriceDisplay(amount) {
    var value = parseFloat(amount);
    if (isNaN(value)) return '';
    return '$' + value.toFixed(2);
  }

  function restoreDrawerPricePreview() {
    var la = window.LensAdvizor;
    if (!la || !la.prices || !la.__ciwTransitionsDrawerPriceSnap) return;
    la.prices.lens = la.__ciwTransitionsDrawerPriceSnap.lens;
    la.prices.subtotal = la.__ciwTransitionsDrawerPriceSnap.subtotal;
    delete la.__ciwTransitionsDrawerPriceSnap;
    if (typeof la.updateFooterPrices === 'function') la.updateFooterPrices();
  }

  function syncDrawerPricePreview() {
    var la = window.LensAdvizor;
    if (!la || !la.prices || !document.body.classList.contains(BODY_CLASS)) {
      restoreDrawerPricePreview();
      return;
    }

    resolvePendingWrapper(scope);
    if (!pendingWrapper || !pendingColor) {
      restoreDrawerPricePreview();
      return;
    }

    var typeName = getTitle(pendingWrapper);
    var lensPrice = getDrawerVariantPrice(typeName, pendingColor);
    if (lensPrice == null) return;

    if (!la.__ciwTransitionsDrawerPriceSnap) {
      la.__ciwTransitionsDrawerPriceSnap = {
        lens: la.prices.lens,
        subtotal: parseFloat(la.prices.subtotal) || 0
      };
    }

    var frame = parseFloat(la.prices.frame) || 0;
    la.prices.lens = lensPrice;
    la.prices.subtotal = frame + lensPrice;
  }

  function syncDrawerCardPrices() {
    if (!scope) return;
    getWrappers(scope).forEach(function (wrapper) {
      var button = getButton(wrapper);
      if (!button) return;
      var typeName = getTitle(wrapper);
      if (!isDrawerType(typeName)) return;

      var priceInline = button.querySelector('.ciw-la-lens-card-price-inline');
      if (!priceInline) return;

      var color =
        wrapper === pendingWrapper && pendingColor
          ? pendingColor
          : getDefaultColorForType(typeName);
      var price = getDrawerVariantPrice(typeName, color);
      if (price == null) return;
      priceInline.textContent = formatDrawerPriceDisplay(price);
    });
  }

  function isMobileViewport() {
    return window.matchMedia('(max-width: 749px)').matches;
  }

  function resetDrawerSelection() {
    restoreDrawerPricePreview();
    pendingWrapper = null;
    pendingColor = '';
    confirming = false;
    drawerConfirmedForward = false;
    document.body.classList.remove(SKIP_CLASS);
    document.body.classList.remove(FORWARD_USED_CLASS);
    restoreRetiredPackageOptionSteps();
  }

  function getDrawerBackButton() {
    return document.querySelector(
      '#lensadvizor-prescription-modal .la-steeper-back:not(:disabled), .ciw-la-gusa-back-btn:not(:disabled)'
    );
  }

  function removeMobileDrawerBackdrop() {
    var modal = document.getElementById('lensadvizor-prescription-modal');
    if (!modal) return;
    var backdrop = modal.querySelector('.' + BACKDROP_CLASS);
    if (backdrop) backdrop.remove();
    document.body.classList.remove(MOBILE_SHEET_CLASS);
  }

  function getMobileSheetRoot() {
    return drawerMountedRoot || scope;
  }

  function resetMobileSheetTransform(root) {
    root = root || getMobileSheetRoot();
    if (!root) return;
    root.classList.remove(DRAGGING_CLASS, DISMISSING_CLASS);
    root.style.transform = '';
    root.style.transition = '';
    var backdrop = document.querySelector(
      '#lensadvizor-prescription-modal .' + BACKDROP_CLASS
    );
    if (backdrop) {
      backdrop.style.opacity = '';
      backdrop.style.transition = '';
    }
    dragState = null;
    dismissing = false;
  }

  function removeMobileSheetHeader(root) {
    if (!root) return;
    var header = root.querySelector('.' + SHEET_HEADER_CLASS);
    if (header) header.remove();
    var legacyHeading = root.querySelector('.la-wrapper-heading');
    if (legacyHeading) {
      legacyHeading.hidden = false;
      var legacyTitle = legacyHeading.querySelector('h3');
      if (legacyTitle && !legacyTitle.id) legacyTitle.id = 'la_prescriptionSelect_title';
    }
    resetMobileSheetTransform(root);
    delete root.dataset.ciwSheetDragBound;
  }

  function bindMobileSheetDrag(root) {
    if (!root || root.dataset.ciwSheetDragBound === '1') return;
    var header = root.querySelector('.' + SHEET_HEADER_CLASS);
    if (!header) return;

    root.dataset.ciwSheetDragBound = '1';

    function isDragTarget(target) {
      if (!target || !header.contains(target)) return false;
      return !target.closest('.' + SHEET_CLOSE_CLASS);
    }

    function onPointerDown(event) {
      if (!document.body.classList.contains(BODY_CLASS) || dismissing) return;
      if (!isDragTarget(event.target)) return;
      if (event.pointerType === 'mouse' && event.button !== 0) return;

      dragState = {
        startY: event.clientY,
        lastY: event.clientY,
        startTime: Date.now(),
        pointerId: event.pointerId,
        sheetHeight: root.getBoundingClientRect().height || 400
      };
      root.classList.add(DRAGGING_CLASS);
      root.style.transition = 'none';
      header.setPointerCapture(event.pointerId);
    }

    function onPointerMove(event) {
      if (!dragState || event.pointerId !== dragState.pointerId) return;
      var dy = Math.max(0, event.clientY - dragState.startY);
      dragState.lastY = event.clientY;
      root.style.transform = 'translateY(' + dy + 'px)';

      var backdrop = document.querySelector(
        '#lensadvizor-prescription-modal .' + BACKDROP_CLASS
      );
      if (backdrop) {
        var fade = Math.min(1, dy / (dragState.sheetHeight * 0.45));
        backdrop.style.opacity = String(Math.max(0.12, 1 - fade * 0.88));
      }

      if (dy > 8) event.preventDefault();
    }

    function onPointerEnd(event) {
      if (!dragState || event.pointerId !== dragState.pointerId) return;

      var dy = Math.max(0, dragState.lastY - dragState.startY);
      var dt = Math.max(1, Date.now() - dragState.startTime);
      var velocity = dy / dt;

      try {
        header.releasePointerCapture(event.pointerId);
      } catch (err) {}

      dragState = null;
      root.classList.remove(DRAGGING_CLASS);

      if (dy > DISMISS_THRESHOLD_PX || velocity > DISMISS_VELOCITY) {
        dismissDrawerWithAnimation();
        return;
      }

      root.style.transition = 'transform 0.22s ease-out';
      root.style.transform = '';
      var backdrop = document.querySelector(
        '#lensadvizor-prescription-modal .' + BACKDROP_CLASS
      );
      if (backdrop) {
        backdrop.style.transition = 'opacity 0.22s ease-out';
        backdrop.style.opacity = '';
        window.setTimeout(function () {
          if (backdrop) backdrop.style.transition = '';
        }, 230);
      }
      window.setTimeout(function () {
        if (root) root.style.transition = '';
      }, 230);
    }

    header.addEventListener('pointerdown', onPointerDown);
    header.addEventListener('pointermove', onPointerMove);
    header.addEventListener('pointerup', onPointerEnd);
    header.addEventListener('pointercancel', onPointerEnd);
  }

  function ensureMobileSheetHeader(root) {
    if (!root || !isMobileViewport()) return;

    var header = root.querySelector('.' + SHEET_HEADER_CLASS);
    if (!header) {
      header = document.createElement('div');
      header.className = SHEET_HEADER_CLASS;
      header.innerHTML =
        '<div class="' +
        DRAG_ZONE_CLASS +
        '" aria-hidden="true"><span class="' +
        HANDLE_CLASS +
        '"></span></div>' +
        '<div class="' +
        TITLE_ROW_CLASS +
        '">' +
        '<h3 class="' +
        SHEET_TITLE_CLASS +
        '" id="la_prescriptionSelect_title"></h3>' +
        '<button type="button" class="' +
        SHEET_CLOSE_CLASS +
        '" aria-label="Close"></button>' +
        '</div>';

      var anchor = root.querySelector('.la-wrapper-heading, .la-label-btn-wrapper');
      if (anchor) root.insertBefore(header, anchor);
      else root.insertBefore(header, root.firstChild);

      header.querySelector('.' + SHEET_CLOSE_CLASS).addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        if (!dismissing) dismissDrawerWithAnimation();
      });
    }

    var sheetTitle = header.querySelector('.' + SHEET_TITLE_CLASS);
    if (sheetTitle) sheetTitle.textContent = STEP_TITLE;

    var legacyHeading = root.querySelector('.la-wrapper-heading');
    if (legacyHeading) {
      legacyHeading.hidden = true;
      var legacyTitle = legacyHeading.querySelector('#la_prescriptionSelect_title');
      if (legacyTitle && legacyTitle !== sheetTitle) legacyTitle.removeAttribute('id');
    }

    bindMobileSheetDrag(root);
  }

  function dismissDrawerWithAnimation() {
    if (dismissing || !document.body.classList.contains(BODY_CLASS)) return;

    var root = getMobileSheetRoot();
    if (!root || !isMobileViewport()) {
      closeDrawerToLensType();
      return;
    }

    dismissing = true;
    root.classList.add(DISMISSING_CLASS);
    root.classList.remove(DRAGGING_CLASS);
    root.style.transition = 'transform 0.28s ease-in';
    root.style.transform = 'translateY(100%)';

    var backdrop = document.querySelector(
      '#lensadvizor-prescription-modal .' + BACKDROP_CLASS
    );
    if (backdrop) {
      backdrop.style.transition = 'opacity 0.28s ease-in';
      backdrop.style.opacity = '0';
    }

    window.setTimeout(function () {
      resetMobileSheetTransform(root);
      closeDrawerToLensType();
    }, 280);
  }

  function unmountMobileDrawerSheet() {
    if (drawerMountedRoot) removeMobileSheetHeader(drawerMountedRoot);
    if (drawerMountedRoot && drawerPlaceholder && drawerPlaceholder.parentNode) {
      drawerPlaceholder.parentNode.insertBefore(drawerMountedRoot, drawerPlaceholder);
      drawerPlaceholder.remove();
    }
    drawerPlaceholder = null;
    drawerMountedRoot = null;
  }

  function mountMobileDrawerSheet(root) {
    if (!isMobileViewport() || !root) return;
    var modal = document.getElementById('lensadvizor-prescription-modal');
    if (!modal) return;

    if (drawerMountedRoot !== root) {
      unmountMobileDrawerSheet();
      drawerPlaceholder = document.createComment('ciw-la-transitions-drawer-anchor');
      if (root.parentNode) {
        root.parentNode.insertBefore(drawerPlaceholder, root);
      }
      modal.appendChild(root);
      drawerMountedRoot = root;
    }

    var backdrop = modal.querySelector('.' + BACKDROP_CLASS);
    if (backdrop && backdrop.nextSibling !== root) {
      modal.insertBefore(backdrop, root);
    }
  }

  function ensureMobileDrawerBackdrop() {
    if (!isMobileViewport()) return;
    var modal = document.getElementById('lensadvizor-prescription-modal');
    if (!modal) return;

    var backdrop = modal.querySelector('.' + BACKDROP_CLASS);
    if (!backdrop) {
      backdrop = document.createElement('button');
      backdrop.type = 'button';
      backdrop.className = BACKDROP_CLASS;
      backdrop.setAttribute('aria-label', 'Close Transitions drawer');
      backdrop.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        dismissDrawerWithAnimation();
      });
      modal.appendChild(backdrop);
    }

    if (drawerMountedRoot && backdrop.nextSibling !== drawerMountedRoot) {
      modal.insertBefore(backdrop, drawerMountedRoot);
    }

    document.body.classList.add(MOBILE_SHEET_CLASS);

    backdrop.style.opacity = '0';
    backdrop.style.transition = 'opacity 0.28s ease-out';
    window.requestAnimationFrame(function () {
      if (backdrop && document.body.classList.contains(BODY_CLASS)) {
        backdrop.style.opacity = '1';
      }
    });
    window.setTimeout(function () {
      if (backdrop) backdrop.style.transition = '';
    }, 300);
  }

  function hideDrawerChromeImmediately() {
    restoreDrawerPricePreview();
    document.body.classList.remove(BODY_CLASS);
    document.body.classList.remove(MOBILE_SHEET_CLASS);
    restoreModalFloatingChrome();
    removeMobileDrawerBackdrop();
    unmountMobileDrawerSheet();
    if (scope) {
      resetMobileSheetTransform(scope);
    }
  }

  function teardownDrawerListeners() {
    if (!scope) return;
    scope.classList.remove(SCOPE_CLASS);
    scope.removeEventListener('pointerdown', onPointerDown, true);
    scope.removeEventListener('pointermove', onPointerMove, true);
    scope.removeEventListener('pointerup', onPointerUp, true);
    scope.removeEventListener('pointercancel', onPointerCancel, true);
    scope.removeEventListener('click', onClick, true);
    scope = null;
    pointerGesture = null;
  }

  function armSkipNativeColorStep() {
    document.body.classList.add(SKIP_CLASS);
  }

  function closeDrawerToLensType() {
    if (!document.body.classList.contains(BODY_CLASS)) return false;

    usedDrawerForward = false;
    document.body.classList.remove(FORWARD_USED_CLASS);
    resetDrawerSelection();
    deactivate();

    var back = getDrawerBackButton();
    if (back) {
      back.click();
      return true;
    }

    return false;
  }

  function onMobileDrawerDismiss(event) {
    if (!isMobileViewport() || !document.body.classList.contains(BODY_CLASS)) return;

    if (event.target.closest('.' + BACKDROP_CLASS)) return;

    if (!event.target.closest('.la-prescription-modal-close, .ciw-la-gusa-close-btn')) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    dismissDrawerWithAnimation();
  }

  function buildComparison() {
    var checkSvg =
      '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none" aria-hidden="true">' +
      '<circle cx="9" cy="9" r="9" fill="#eef8f0"/>' +
      '<path d="M5 9.2l2.3 2.3 5.7-5.8" stroke="#1e8a43" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>' +
      '</svg>';

    function buildFeatureList(items) {
      return (
        '<ul class="ciw-la-transitions-compare__features">' +
        items
          .map(function (text) {
            return (
              '<li class="ciw-la-transitions-compare__feature">' +
              '<span class="ciw-la-transitions-compare__check">' +
              checkSvg +
              '</span><span>' +
              text +
              '</span></li>'
            );
          })
          .join('') +
        '</ul>'
      );
    }

    var genSFeatures = [
      'Blocks 100% UVA and UVB',
      'Darkens in seconds outdoors',
      'Fast intense-light recovery',
      'Fully clear indoors, 8 colors outdoors'
    ];

    var xtrFeatures = [
      'Blocks 100% UVA and UVB',
      'Extra dark in hot temperatures',
      'Darkens inside the car',
      'Clear indoors with a hint of protective tint'
    ];

    var section = document.createElement('section');
    section.className = 'ciw-la-transitions-compare';
    section.innerHTML =
      '<button class="ciw-la-transitions-compare__toggle" type="button" aria-expanded="false">' +
      '<span>Compare Transitions lens types</span>' +
      '<span class="ciw-la-transitions-compare__chevron" aria-hidden="true"></span></button>' +
      '<div class="ciw-la-transitions-compare__body" hidden>' +
      '<div class="ciw-la-transitions-compare__viewport">' +
      '<div class="ciw-la-transitions-compare__track">' +
      '<article class="ciw-la-transitions-compare__slide">' +
      '<p class="ciw-la-transitions-compare__eyebrow">OUR BEST EVERYDAY LENS</p>' +
      '<h4 class="ciw-la-transitions-compare__lens-name">Transitions® GEN S™</h4>' +
      buildFeatureList(genSFeatures) +
      '</article>' +
      '<article class="ciw-la-transitions-compare__slide">' +
      '<p class="ciw-la-transitions-compare__eyebrow">FOR EXTRA LIGHT PROTECTION</p>' +
      '<h4 class="ciw-la-transitions-compare__lens-name">Transitions® XTRActive®</h4>' +
      buildFeatureList(xtrFeatures) +
      '</article></div></div>' +
      '<div class="ciw-la-transitions-compare__nav">' +
      '<button type="button" data-dir="-1" aria-label="Previous lens type">‹</button>' +
      '<span class="ciw-la-transitions-compare__pager"><b>1</b> / 2</span>' +
      '<button type="button" data-dir="1" aria-label="Next lens type">›</button>' +
      '</div></div>';
    return section;
  }

  function syncComparePager(track) {
    if (!track || !track.clientWidth) return;
    var compare = track.closest('.ciw-la-transitions-compare');
    var count = compare && compare.querySelector('.ciw-la-transitions-compare__nav b');
    if (!count) return;
    var idx = Math.round(track.scrollLeft / track.clientWidth);
    count.textContent = String(Math.min(1, Math.max(0, idx)) + 1);
  }

  function bindCompareCarousel(compare) {
    if (!compare || compare.dataset.ciwCompareBound === '1') return;
    var track = compare.querySelector('.ciw-la-transitions-compare__track');
    if (!track) return;
    compare.dataset.ciwCompareBound = '1';
    track.addEventListener(
      'scroll',
      function () {
        syncComparePager(track);
      },
      { passive: true }
    );
  }

  function ensureDrawerChrome(root) {
    ensureColorPreview(root);

    var compare = root.querySelector('.ciw-la-transitions-compare');
    if (!compare || compare.querySelector('.ciw-la-transitions-compare__grid')) {
      if (compare) compare.remove();
      compare = buildComparison();
      root.appendChild(compare);
    }
    bindCompareCarousel(compare);

    if (isMobileViewport()) {
      ensureMobileSheetHeader(root);
    } else {
      removeMobileSheetHeader(root);
      var title =
        root.querySelector('#la_prescriptionSelect_title') ||
        root.querySelector('.la-wrapper-heading h3');
      if (title && norm(title.textContent) !== STEP_TITLE) title.textContent = STEP_TITLE;
    }
  }

  function pruneDuplicateWrappers(root) {
    root = root || scope;
    if (!root) return;
    var seen = {};
    Array.prototype.forEach.call(root.children, function (el) {
      if (!el.classList || !el.classList.contains('la-label-btn-wrapper')) return;
      var key = getTitle(el).toLowerCase();
      if (!key) return;
      if (seen[key]) {
        el.classList.add('ciw-la-transitions-drawer__option--hidden');
        el.setAttribute('aria-hidden', 'true');
        return;
      }
      seen[key] = true;
      if (!isExcludedType(getTitle(el))) {
        el.classList.remove('ciw-la-transitions-drawer__option--hidden');
        el.removeAttribute('aria-hidden');
      }
    });
  }

  function reorderDrawerCards(root) {
    var wrappers = getWrappers(root);
    var genS = null;
    var xtr = null;
    var photo = null;
    var other = [];
    var hidden = [];
    var i;

    for (i = 0; i < wrappers.length; i++) {
      var wrapper = wrappers[i];
      var title = getTitle(wrapper);

      if (isExcludedType(title)) {
        wrapper.classList.add('ciw-la-transitions-drawer__option--hidden');
        hidden.push(wrapper);
        continue;
      }

      wrapper.classList.remove('ciw-la-transitions-drawer__option--hidden');

      if (isGenS(title)) genS = wrapper;
      else if (isXtr(title)) xtr = wrapper;
      else if (isPhotocromic(title)) photo = wrapper;
      else other.push(wrapper);
    }

    var ordered = [genS, xtr, photo].concat(other).concat(hidden).filter(Boolean);
    var anchor = root.querySelector('.ciw-la-transitions-compare');

    ordered.forEach(function (wrapper) {
      if (anchor) root.insertBefore(wrapper, anchor);
      else root.appendChild(wrapper);
    });
  }

  function getDrawerPriceText(priceEl) {
    if (!priceEl) return '';
    var clone = priceEl.cloneNode(true);
    var compare = clone.querySelector('.la-compare-at-price');
    if (compare) compare.remove();
    var raw = norm(clone.textContent).replace(/^\+/, function (m) {
      return m;
    });
    if (!raw || /^selected$/i.test(raw.replace(/^\+/, '').trim())) return '';
    return raw;
  }

  function ensureDrawerCardLayout(button) {
    if (!button) return;

    var title = button.querySelector('.la-label-title');
    if (!title) return;

    var description = button.querySelector('.la-label-description');
    var price = button.querySelector('.la-label-price');
    var swatches = button.querySelector('.ciw-la-transitions-drawer__swatches');
    var contentBox = button.querySelector('.la-label-content-box');

    var head = button.querySelector('.ciw-la-lens-card-head');
    if (!head) {
      head = document.createElement('div');
      head.className = 'ciw-la-lens-card-head';
      button.insertBefore(head, button.firstChild);
    }

    var titleRow = head.querySelector('.ciw-la-lens-card-title-row');
    if (!titleRow) {
      titleRow = document.createElement('div');
      titleRow.className = 'ciw-la-lens-card-title-row';
      head.appendChild(titleRow);
    }

    if (title.parentNode !== titleRow) {
      titleRow.appendChild(title);
    }

    if (head.parentNode !== button) {
      button.insertBefore(head, button.firstChild);
    }

    var priceText = getDrawerPriceText(price);
    var priceInline = button.querySelector('.ciw-la-lens-card-price-inline');
    if (priceText) {
      if (!priceInline) {
        priceInline = document.createElement('span');
        priceInline.className = 'ciw-la-lens-card-price-inline';
        button.appendChild(priceInline);
      }
      priceInline.textContent = priceText;
      if (price) price.classList.add('ciw-la-lens-card-price-hidden');
    }

    if (description) {
      if (description.parentNode !== button || description.previousElementSibling !== head) {
        head.insertAdjacentElement('afterend', description);
      }
    }

    if (contentBox) {
      contentBox.remove();
    }

    if (swatches && swatches.parentNode === button) {
      button.appendChild(swatches);
    }

    button.classList.add('ciw-la-lens-card--ready');
  }

  function ensureCard(wrapper) {
    var typeName = getTitle(wrapper);
    var button = getButton(wrapper);
    if (!button) return;

    wrapper.classList.toggle('ciw-la-transitions-drawer__option--hidden', isExcludedType(typeName));

    if (!isOfferedType(typeName) && !isPhotocromic(typeName)) return;

    button.classList.add('ciw-la-transitions-drawer__option');
    button.classList.toggle('ciw-la-transitions-drawer__option--photocromic', isPhotocromic(typeName));
    ensureDrawerCardLayout(button);
    var drawerPrice = button.querySelector('.ciw-la-transitions-drawer__price');
    if (drawerPrice) drawerPrice.remove();

    var colors = getColors(typeName);
    var swatches = button.querySelector('.ciw-la-transitions-drawer__swatches');
    if (!swatches) {
      swatches = document.createElement('div');
      swatches.className = 'ciw-la-transitions-drawer__swatches';
      swatches.setAttribute('role', 'group');
      button.appendChild(swatches);
    }
    swatches.setAttribute('aria-label', typeName + ' colors');
    swatches.classList.toggle('ciw-la-transitions-drawer__swatches--dense', colors.length >= 6);

    colors.forEach(function (color, index) {
      var item = swatches.children[index];
      if (!item) {
        item = document.createElement('button');
        item.type = 'button';
        item.className = SWATCH_CLASS;
        item.innerHTML = '<span aria-hidden="true"></span><small></small>';
        swatches.appendChild(item);
      }
      item.dataset.ciwTransitionsColor = color;
      item.setAttribute('aria-label', displayColor(color));
      item.querySelector('span').style.backgroundColor = colorValue(color);
      item.querySelector('small').textContent = displayColor(color);
    });
    while (swatches.children.length > colors.length) swatches.lastChild.remove();

    ensureDrawerCardLayout(button);
  }

  function render(root) {
    root.classList.add(SCOPE_CLASS);
    ensureDrawerChrome(root);
    if (isMobileViewport() && document.body.classList.contains(BODY_CLASS)) {
      hideModalFloatingChrome();
    }
    getWrappers(root).forEach(ensureCard);
    pruneDuplicateWrappers(root);
    reorderDrawerCards(root);
    syncSelection();
    syncColorPreview(root);
  }

  function resolvePendingWrapper(root) {
    if (!pendingWrapper) return null;
    root = root || scope;
    if (root && root.contains(pendingWrapper)) return pendingWrapper;

    var title = getTitle(pendingWrapper).toLowerCase();
    if (!title || !root) return pendingWrapper;

    var wrappers = getWrappers(root);
    var i;
    for (i = 0; i < wrappers.length; i++) {
      if (getTitle(wrappers[i]).toLowerCase() === title) {
        pendingWrapper = wrappers[i];
        return pendingWrapper;
      }
    }
    return pendingWrapper;
  }

  function syncSelection() {
    if (!scope) return;
    resolvePendingWrapper(scope);
    getWrappers(scope).forEach(function (wrapper) {
      var selected = wrapper === pendingWrapper;
      var button = getButton(wrapper);
      if (button) button.classList.toggle(PICKED_CLASS, selected);
      wrapper.querySelectorAll('.' + SWATCH_CLASS).forEach(function (swatch) {
        var picked = selected && norm(swatch.dataset.ciwTransitionsColor) === pendingColor;
        swatch.classList.toggle(SWATCH_PICKED_CLASS, picked);
        swatch.setAttribute('aria-pressed', picked ? 'true' : 'false');
        var label = swatch.querySelector('small');
        if (label) label.classList.toggle('is-visible', picked);
      });
    });
    syncColorPreview(scope);
    syncDrawerCardPrices();
    syncDrawerPricePreview();
    document.dispatchEvent(new CustomEvent('ciw-la-transitions-drawer:changed'));
  }

  function select(wrapper, color) {
    if (!wrapper) return;
    freshDrawerEntry = false;
    var typeName = getTitle(wrapper);
    if (!isDrawerType(typeName)) return;
    pendingWrapper = wrapper;
    if (color) {
      pendingColor = norm(color);
    } else {
      pendingColor = getDefaultColorForType(typeName);
    }
    if (getColors(typeName).indexOf(pendingColor) === -1) {
      pendingColor = getDefaultColorForType(typeName);
    }
    if (scope) {
      getWrappers(scope).forEach(function (item) {
        var input = getRadio(item);
        if (input) input.checked = false;
      });
    }
    syncSelection();
  }

  function commitDrawerPick(wrapper, color) {
    if (!wrapper) return;
    lastPointerPickAt = Date.now();
    select(wrapper, color || getDefaultColorForType(getTitle(wrapper)));
  }

  function onPointerDown(event) {
    var target = getEventElement(event.target);
    if (!target) return;

    var toggle = target.closest('.ciw-la-transitions-compare__toggle');
    var nav = target.closest('.ciw-la-transitions-compare__nav button');
    if (toggle || nav) return;

    var swatch = target.closest('.' + SWATCH_CLASS);
    var wrapper = target.closest('.la-label-btn-wrapper');
    if (!wrapper || !isDrawerType(getTitle(wrapper))) return;

    var swatchRow = swatch
      ? swatch.closest('.ciw-la-transitions-drawer__swatches')
      : target.closest('.ciw-la-transitions-drawer__swatches');

    pointerGesture = {
      wrapper: wrapper,
      swatch: swatch,
      color: swatch ? swatch.dataset.ciwTransitionsColor : '',
      startX: event.clientX,
      startY: event.clientY,
      pointerId: event.pointerId,
      moved: false,
      scrollLeftStart: swatchRow ? swatchRow.scrollLeft : 0,
      swatchRow: swatchRow
    };
  }

  function onPointerMove(event) {
    if (!pointerGesture || event.pointerId !== pointerGesture.pointerId) return;
    var dx = Math.abs(event.clientX - pointerGesture.startX);
    var dy = Math.abs(event.clientY - pointerGesture.startY);
    if (dx > TAP_MOVE_THRESHOLD_PX || dy > TAP_MOVE_THRESHOLD_PX) {
      pointerGesture.moved = true;
    }
  }

  function finishPointerGesture(event) {
    if (!pointerGesture || event.pointerId !== pointerGesture.pointerId) return;

    var gesture = pointerGesture;
    pointerGesture = null;
    if (gesture.moved) return;
    if (
      gesture.swatchRow &&
      Math.abs(gesture.swatchRow.scrollLeft - gesture.scrollLeftStart) > SWATCH_SCROLL_THRESHOLD_PX
    ) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    if (gesture.swatch) {
      commitDrawerPick(gesture.wrapper, gesture.color);
      return;
    }

    commitDrawerPick(gesture.wrapper, getDefaultColorForType(getTitle(gesture.wrapper)));
  }

  function onPointerUp(event) {
    finishPointerGesture(event);
  }

  function onPointerCancel(event) {
    if (pointerGesture && event.pointerId === pointerGesture.pointerId) {
      pointerGesture = null;
    }
  }

  function onClick(event) {
    var target = getEventElement(event.target);
    if (!target) return;

    var toggle = target.closest('.ciw-la-transitions-compare__toggle');
    if (toggle) {
      var compareSection = toggle.closest('.ciw-la-transitions-compare');
      var body = compareSection && compareSection.querySelector('.ciw-la-transitions-compare__body');
      var open = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', open ? 'false' : 'true');
      if (compareSection) compareSection.classList.toggle('is-open', !open);
      if (body) body.hidden = open;
      return;
    }

    var nav = target.closest('.ciw-la-transitions-compare__nav button');
    if (nav && scope) {
      var compareSection = scope.querySelector('.ciw-la-transitions-compare');
      var track = compareSection && compareSection.querySelector('.ciw-la-transitions-compare__track');
      if (track) {
        var idx = Math.round(track.scrollLeft / track.clientWidth);
        var next = nav.dataset.dir === '1' ? Math.min(1, idx + 1) : Math.max(0, idx - 1);
        track.scrollTo({ left: next * track.clientWidth, behavior: 'smooth' });
        syncComparePager(track);
      }
      return;
    }

    var swatch = target.closest('.' + SWATCH_CLASS);
    var wrapper = target.closest('.la-label-btn-wrapper');
    if (!wrapper || !isDrawerType(getTitle(wrapper))) return;
    if (Date.now() - lastPointerPickAt < 500) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      return;
    }
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    commitDrawerPick(wrapper, swatch ? swatch.dataset.ciwTransitionsColor : getDefaultColorForType(getTitle(wrapper)));
  }

  function getActiveStepTitle() {
    var title = document.querySelector(
      '#lensadvizor-prescription-modal #la_prescriptionSelect_title, #lensadvizor-prescription-modal .la-wrapper-heading h3'
    );
    return norm(title && title.textContent);
  }

  function isColorOptionRadio(radio) {
    var wrapper = radio && radio.closest('.la-label-btn-wrapper');
    if (!wrapper) return false;
    var title = getTitle(wrapper).toLowerCase();
    if (/polycarbonate|premium|supreme|basic|standard|index|thickness|upgrade/i.test(title)) {
      return false;
    }
    return true;
  }

  function findColorRadio(color) {
    var target = norm(color).toLowerCase();
    var radios = document.querySelectorAll(
      '#lensadvizor-prescription-modal .la-render-options input[type="radio"].la-tap-select'
    );
    for (var i = 0; i < radios.length; i++) {
      if (!isColorOptionRadio(radios[i])) continue;
      var wrapper = radios[i].closest('.la-label-btn-wrapper');
      if (wrapper && getTitle(wrapper).toLowerCase() === target) return radios[i];
      if (norm(radios[i].value).toLowerCase() === target) return radios[i];
    }
    return null;
  }

  function shouldSkipCombinedNonRxOptionsSubmit(options) {
    if (!options) return false;
    var colorApi = window.ciwLaLensColorContinue;
    if (
      !colorApi ||
      typeof colorApi.isNonPrescriptionCombinedScope !== 'function' ||
      !colorApi.isNonPrescriptionCombinedScope(options)
    ) {
      return false;
    }
    return true;
  }

  function applyColorRadio(radio) {
    if (!radio) return;
    var la = window.LensAdvizor;
    radio.checked = true;
    if (la && typeof la.handleSingleOptionChange === 'function') {
      la.handleSingleOptionChange({ target: radio });
    } else if (la && typeof la.handleOptionChange === 'function') {
      la.handleOptionChange({ target: radio, type: 'click' });
    }
    radio.dispatchEvent(new Event('change', { bubbles: true }));

    var options = radio.closest('.la-choose-prescription-wrapper.la-render-options');
    if (shouldSkipCombinedNonRxOptionsSubmit(options)) {
      if (
        window.ciwLaLensColorContinue &&
        typeof window.ciwLaLensColorContinue.markCombinedColorConfirmedFromDrawer === 'function'
      ) {
        window.ciwLaLensColorContinue.markCombinedColorConfirmedFromDrawer();
      }
      return;
    }

    if (options) {
      if (typeof options.requestSubmit === 'function') {
        options.requestSubmit();
      } else {
        options.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
      }
    }
  }

  function isProgressivePrescriptionFlow() {
    var la = window.LensAdvizor;
    if (la && la.response && la.response.selectedPrescriptionType) {
      var selected = la.response.selectedPrescriptionType;
      var text = '';
      if (typeof selected === 'string') {
        text = selected;
      } else if (selected) {
        text = [selected.title, selected.name, selected.type, selected.handle]
          .filter(Boolean)
          .join(' ');
      }
      if (/progressive/i.test(text)) return true;
    }
    return false;
  }

  function isProgressiveTransitionsFlow() {
    return isTransitionsLensFlow() && isProgressivePrescriptionFlow();
  }

  function flushDownstreamTransitionGates() {
    document.body.classList.remove(SKIP_CLASS);
    document.body.classList.remove(FORWARD_USED_CLASS);
    tagProgressiveTypeScopeIfNeeded();
  }

  function finishConfirm() {
    if (!confirming) return;
    var lastScope = scope;
    hideStaleTransitionTypeSteps(lastScope);
    hideDrawerChromeImmediately();
    teardownDrawerListeners();
    confirming = false;
    drawerConfirmedForward = false;
    usedDrawerForward = true;
    pendingWrapper = null;
    pendingColor = '';
    flushDownstreamTransitionGates();
    window.requestAnimationFrame(flushDownstreamTransitionGates);
    document.dispatchEvent(new CustomEvent('ciw-la-transitions-drawer:confirmed'));
    document.dispatchEvent(new CustomEvent('ciw-la-lens-package:continue-sync'));
    scheduleScan();
  }

  function isConfirmAdvanceComplete() {
    var titleText = getActiveStepTitle();
    if (
      /choose lens package|available upgrade|review your selection|lens thickness|lens index|progressive type/i.test(
        titleText
      )
    ) {
      return true;
    }

    var downstreamSelectors = [
      '.la-choose-prescription-wrapper.ciw-la-lens-package-step',
      '.la-choose-prescription-wrapper.la-render-options.ciw-la-lens-package-step',
      '.la-choose-prescription-wrapper.ciw-la-progressive-type-options-step',
      '.la-choose-prescription-wrapper.ciw-la-lens-thickness-step',
      '.la-choose-prescription-wrapper.la-render-addons',
      '.la-choose-prescription-wrapper.la-render-review'
    ];
    var i;
    for (i = 0; i < downstreamSelectors.length; i++) {
      var step = document.querySelector(downstreamSelectors[i]);
      if (step && isVisible(step)) return true;
    }

    return false;
  }

  function waitForColorAdvance(color, attempt) {
    if (isProgressiveTransitionsFlow()) {
      hideNativeColorStep();
      if (findProgressiveTypeScopeByCards({ ignoreVisibility: true })) {
        tagProgressiveTypeScopeIfNeeded({ ignoreVisibility: true });
        finishConfirm();
        return;
      }
    }

    if (isConfirmAdvanceComplete()) {
      finishConfirm();
      return;
    }

    if (/choose\s+progressive\s+type|progressive\s+type|choose lens package|lens package/i.test(getActiveStepTitle())) {
      finishConfirm();
      return;
    }

    if (/select.*color/i.test(getActiveStepTitle())) {
      var radio = findColorRadio(color);
      if (radio) applyColorRadio(radio);
    }

    if (attempt > 20) {
      finishConfirm();
      return;
    }

    window.setTimeout(function () {
      waitForColorAdvance(color, attempt + 1);
    }, isProgressiveTransitionsFlow() ? 16 : 40);
  }

  function waitForColor(color, attempt) {
    if (isConfirmAdvanceComplete()) {
      finishConfirm();
      return;
    }

    /* Drawer already committed type + color — progressive flows skip LA's native color step. */
    if (isProgressiveTransitionsFlow() && pendingColor && pendingWrapper) {
      waitForColorAdvance(color, 0);
      return;
    }

    var radio = findColorRadio(color);
    if (radio) {
      applyColorRadio(radio);
      window.requestAnimationFrame(function () {
        waitForColorAdvance(color, 0);
      });
      return;
    }

    if (!/select.*color/i.test(getActiveStepTitle()) || attempt >= 3) {
      waitForColorAdvance(color, 0);
      return;
    }

    if (attempt < 12) {
      window.setTimeout(function () {
        waitForColor(color, attempt + 1);
      }, 40);
      return;
    }

    waitForColorAdvance(color, 0);
  }

  function confirmSelection() {
    if (!scope || confirming) return;
    resolvePendingWrapper(scope);
    if (!pendingWrapper) return;
    if (!pendingColor) return;

    var radio = getRadio(pendingWrapper);
    var la = window.LensAdvizor;
    if (!radio || !la || typeof la.handleLensChange !== 'function') return;

    confirming = true;
    drawerConfirmedForward = true;
    armSkipNativeColorStep();
    hideDrawerChromeImmediately();
    getWrappers(scope).forEach(function (wrapper) {
      var input = getRadio(wrapper);
      if (input) input.checked = wrapper === pendingWrapper;
    });
    la.handleLensChange({ target: radio });
    if (isProgressiveTransitionsFlow()) {
      startProgressiveTypeReleaseBurst();
    }
    waitForColor(pendingColor, 0);
  }

  function isNativeColorStepActive() {
    if (/select.*color/i.test(getActiveStepTitle())) return true;

    var options = document.querySelector('.la-choose-prescription-wrapper.la-render-options');
    if (!options || options.hidden || options.classList.contains('ciw-la-lens-package-step')) {
      return false;
    }
    if (window.getComputedStyle(options).display === 'none') return false;

    var title =
      options.querySelector('#la_prescriptionSelect_title') ||
      options.querySelector('.la-wrapper-heading h3');
    return /select.*color/i.test(norm(title && title.textContent));
  }

  function isNativeColorStepVisible() {
    var options = document.querySelector('.la-choose-prescription-wrapper.la-render-options');
    if (!options || !isVisible(options)) return false;
    var title =
      options.querySelector('#la_prescriptionSelect_title') ||
      options.querySelector('.la-wrapper-heading h3');
    return /select.*color/i.test(norm(title && title.textContent));
  }

  function isIntermediateColorStep() {
    if (!isTransitionsLensFlow()) return false;
    if (!isNativeColorStepActive()) return false;
    return (
      confirming ||
      !!pendingWrapper ||
      drawerConfirmedForward ||
      usedDrawerForward ||
      document.body.classList.contains(FORWARD_USED_CLASS)
    );
  }

  function queueSkipIntermediateBack() {
    if (skipBackQueued || skippingBack || !isIntermediateColorStep()) return false;
    skipBackQueued = true;
    window.setTimeout(function () {
      skipBackQueued = false;
      skipIntermediateBack();
    }, 0);
    return true;
  }

  function queueResumeDrawerFromPackageBack() {
    if (resumeDrawerFromPackageBack._queued || skippingBack) return false;
    resumeDrawerFromPackageBack._queued = true;
    resumeDrawerFromPackageBack(0);
    return true;
  }

  function resumeDrawerFromPackageBack(attempt) {
    if (!isTransitionsLensFlow()) {
      resumeDrawerFromPackageBack._queued = false;
      return;
    }
    if (!canResumeDrawerAfterForward()) {
      resumeDrawerFromPackageBack._queued = false;
      return;
    }

    if (
      document.body.classList.contains(BODY_CLASS) ||
      /choose transition type/i.test(getActiveStepTitle())
    ) {
      document.body.classList.remove(SKIP_CLASS);
      document.body.classList.remove(FORWARD_USED_CLASS);
      resumeDrawerFromPackageBack._queued = false;
      return;
    }

    if (isProgressiveTypeStepActive()) {
      document.body.classList.remove(FORWARD_USED_CLASS);
      tagProgressiveTypeScopeIfNeeded();
      if (findTransitionDrawerRoot() && reopenDrawerFromForwardBack()) {
        resumeDrawerFromPackageBack._queued = false;
        return;
      }
    }

    armSkipNativeColorStep();
    hideNativeColorStep();
    if (isNativeColorStepActive()) {
      resumeDrawerFromPackageBack._queued = false;
      if (!skipIntermediateBack()) queueSkipIntermediateBack();
      return;
    }
    if (attempt > 45) {
      resumeDrawerFromPackageBack._queued = false;
      return;
    }
    window.setTimeout(function () {
      resumeDrawerFromPackageBack(attempt + 1);
    }, 80);
  }

  function skipIntermediateBack() {
    if (skippingBack || !isIntermediateColorStep()) return false;
    var back = document.querySelector(
      '#lensadvizor-prescription-modal .la-steeper-back:not(:disabled), .ciw-la-gusa-back-btn:not(:disabled)'
    );
    if (!back) return false;
    skippingBack = true;
    armSkipNativeColorStep();
    programmaticBackNavigation = true;
    back.click();
    programmaticBackNavigation = false;
    window.setTimeout(function () {
      skippingBack = false;
      document.body.classList.remove(SKIP_CLASS);
      scheduleScan();
    }, 280);
    return true;
  }

  function hideModalFloatingChrome() {
    var modal = document.getElementById('lensadvizor-prescription-modal');
    if (!modal) return;
    var back = modal.querySelector(':scope > .ciw-la-gusa-back-btn');
    var close = modal.querySelector(':scope > .la-prescription-modal-close.ciw-la-gusa-close-btn');
    if (back) back.style.setProperty('display', 'none', 'important');
    if (close) close.style.setProperty('display', 'none', 'important');
  }

  function restoreModalFloatingChrome() {
    var modal = document.getElementById('lensadvizor-prescription-modal');
    if (!modal) return;
    var back = modal.querySelector(':scope > .ciw-la-gusa-back-btn');
    var close = modal.querySelector(':scope > .la-prescription-modal-close.ciw-la-gusa-close-btn');
    if (back) back.style.removeProperty('display');
    if (close) close.style.removeProperty('display');
  }

  function shouldRestoreFromLa() {
    if (pendingWrapper || freshDrawerEntry) return false;
    if (skipRestoreOnNextActivate || Date.now() < skipRestoreUntil) return false;
    return true;
  }

  function hideStaleTransitionTypeSteps(keepRoot) {
    if (!isTransitionsLensFlow() && !document.body.classList.contains(BODY_CLASS)) return;
    getTransitionTypeRoots().forEach(function (el) {
      if (keepRoot && el === keepRoot) return;
      if (!isTransitionsTypeScope(el)) return;
      el.classList.add('ciw-la-transitions-drawer__step-retired');
      el.hidden = true;
      el.setAttribute('aria-hidden', 'true');
    });
  }

  function restoreVisibleLensPackageSteps() {
    restoreWronglyRetiredLensPackageSteps();
    restoreRetiredPackageOptionSteps();
  }

  function revealTransitionTypeStep(root) {
    revealRetiredStep(root);
  }

  function cleanupStaleDrawerScopes(activeRoot) {
    document.querySelectorAll('.' + SCOPE_CLASS).forEach(function (el) {
      if (el === activeRoot) return;
      el.classList.remove(SCOPE_CLASS);
      removeMobileSheetHeader(el);
    });
  }

  function refreshDrawerCards(root) {
    getWrappers(root).forEach(ensureCard);
    pruneDuplicateWrappers(root);
    reorderDrawerCards(root);
  }

  function activate(root, opts) {
    opts = opts || {};
    var isResume =
      !!opts.resume ||
      document.body.classList.contains(FORWARD_USED_CLASS) ||
      usedDrawerForward;

    cleanupStaleDrawerScopes(root);
    revealTransitionTypeStep(root);
    hideStaleTransitionTypeSteps(root);
    document.body.classList.remove(FORWARD_USED_CLASS);
    if (isResume) {
      document.body.classList.add(RESUMING_CLASS);
    }
    if (scope !== root) {
      if (scope) {
        scope.classList.remove(SCOPE_CLASS);
        scope.removeEventListener('pointerdown', onPointerDown, true);
        scope.removeEventListener('pointermove', onPointerMove, true);
        scope.removeEventListener('pointerup', onPointerUp, true);
        scope.removeEventListener('pointercancel', onPointerCancel, true);
        scope.removeEventListener('click', onClick, true);
      }
      scope = root;
      scope.addEventListener('pointerdown', onPointerDown, true);
      scope.addEventListener('pointermove', onPointerMove, true);
      scope.addEventListener('pointerup', onPointerUp, true);
      scope.addEventListener('pointercancel', onPointerCancel, true);
      scope.addEventListener('click', onClick, true);
    }
    document.body.classList.add(BODY_CLASS);
    document.body.classList.remove(SKIP_CLASS);
    if (isMobileViewport()) {
      hideModalFloatingChrome();
      mountMobileDrawerSheet(root);
      if (isResume) {
        root.scrollTop = 0;
        root.dataset.ciwSheetEntered = '1';
      } else if (root.dataset.ciwSheetEntered !== '1') {
        window.setTimeout(function () {
          if (scope === root) root.dataset.ciwSheetEntered = '1';
        }, 300);
      }
      if (!document.querySelector('#lensadvizor-prescription-modal .' + BACKDROP_CLASS)) {
        if (isResume) {
          ensureMobileDrawerBackdrop();
          var resumeBackdrop = document.querySelector(
            '#lensadvizor-prescription-modal .' + BACKDROP_CLASS
          );
          if (resumeBackdrop) resumeBackdrop.style.opacity = '1';
        } else {
          ensureMobileDrawerBackdrop();
        }
      }
    }
    if (shouldRestoreFromLa()) {
      restoreSelectionFromLa();
    }
    render(root);
    skipRestoreOnNextActivate = false;
    syncSelection();

    if (isResume) {
      window.requestAnimationFrame(function () {
        document.body.classList.remove(RESUMING_CLASS);
      });
    }

    window.setTimeout(function () {
      if (scope !== root) return;
      if (shouldRestoreFromLa()) restoreSelectionFromLa();
      refreshDrawerCards(root);
      syncSelection();
    }, 200);
  }

  function deactivate() {
    hideDrawerChromeImmediately();
    teardownDrawerListeners();
  }

  function restoreSelectionFromLa() {
    if (pendingWrapper) return;
    var la = window.LensAdvizor;
    if (!la || !la.response || !la.response.lens) return;

    var lens = la.response.lens;
    if (!isOfferedType(lens.name) && !isPhotocromic(lens.name)) return;

    var wrappers = getWrappers(scope);
    var i;
    for (i = 0; i < wrappers.length; i++) {
      if (norm(getTitle(wrappers[i])).toLowerCase() === norm(lens.name).toLowerCase()) {
        pendingWrapper = wrappers[i];
        break;
      }
    }
    if (!pendingWrapper) return;

    var color = '';
    if (la.response.lensVariant && la.response.lensVariant.option1) {
      color = norm(la.response.lensVariant.option1);
    } else if (la.response.raw_options && la.response.raw_options.option1) {
      color = norm(la.response.raw_options.option1);
    }
    if (color) pendingColor = color;
  }

  function scan() {
    if (!window.ciwLaHostApi || !window.ciwLaHostApi.isEyeglass()) {
      deactivate();
      return;
    }
    if (isSunglassesLensFlowActive() || /^lens type$/i.test(getActiveStepTitle())) {
      clearTransitionsFlowPollution();
    }
    if (/^lens type$/i.test(getActiveStepTitle())) {
      skipRestoreOnNextActivate = true;
      skipRestoreUntil = Date.now() + 5000;
      freshDrawerEntry = true;
      usedDrawerForward = false;
      document.body.classList.remove(FORWARD_USED_CLASS);
      resetDrawerSelection();
      deactivate();
      return;
    }
    if (confirming && drawerConfirmedForward && /select.*color/i.test(getActiveStepTitle())) {
      armSkipNativeColorStep();
      return;
    }
    if (isDownstreamStepVisible()) {
      clearSkipForVisibleDownstreamStep();
      restoreVisibleLensPackageSteps();
      hideStaleTransitionTypeSteps(null);
      document.body.classList.remove(FORWARD_USED_CLASS);
      tagProgressiveTypeScopeIfNeeded();
      if (document.body.classList.contains(BODY_CLASS) || confirming) {
        hideDrawerChromeImmediately();
        if (confirming && isConfirmAdvanceComplete()) {
          finishConfirm();
          return;
        }
        if (!confirming && !skippingBack) {
          teardownDrawerListeners();
        }
      } else if (!confirming && !skippingBack) {
        deactivate();
      }
      return;
    }
    if (document.body.classList.contains(FORWARD_USED_CLASS) && isNativeColorStepActive()) {
      if (!isTransitionsLensFlow()) {
        clearTransitionsFlowPollution();
      } else {
        hideNativeColorStep();
        if (findTransitionDrawerRoot() && reopenDrawerFromForwardBack()) return;
        if (queueSkipIntermediateBack()) return;
        if (skipIntermediateBack()) return;
      }
    }
    if (queueSkipIntermediateBack()) return;
    if (skipIntermediateBack()) return;
    var root = getScope();
    if (!root) {
      if (!confirming && !skippingBack) deactivate();
      return;
    }

    var activeTitle = document.querySelector(
      '#lensadvizor-prescription-modal #la_prescriptionSelect_title, #lensadvizor-prescription-modal .la-wrapper-heading h3'
    );
    if (norm(activeTitle && activeTitle.textContent) === STEP_TITLE) {
      drawerConfirmedForward = false;
    }

    if (scope === root && document.body.classList.contains(BODY_CLASS)) {
      var now = Date.now();
      if (now - lastDrawerCardRefresh > 280) {
        lastDrawerCardRefresh = now;
        refreshDrawerCards(root);
      }
      syncSelection();
      return;
    }

    activate(root);
  }

  function scheduleScan() {
    if (scanQueued) return;
    scanQueued = true;
    window.requestAnimationFrame(function () {
      scanQueued = false;
      scan();
    });
    [100, 250, 500, 900].forEach(function (delay) {
      window.setTimeout(scan, delay);
    });
  }

  function scheduleScanFromMutation() {
    if (moScanQueued) return;
    moScanQueued = true;
    window.requestAnimationFrame(function () {
      moScanQueued = false;
      scheduleScan();
    });
  }

  window.ciwLaTransitionsDrawer = {
    isActive: function () {
      return document.body.classList.contains(BODY_CLASS);
    },
    hideStaleTransitionSteps: hideStaleTransitionTypeSteps,
    clearFlowPollution: clearTransitionsFlowPollution,
    isContinueEnabled: function () {
      resolvePendingWrapper(scope);
      if (!pendingWrapper || confirming) return false;
      return !!pendingColor;
    },
    isFooterContinueReady: function () {
      return !confirming;
    },
    confirm: confirmSelection,
    alertIfMissingColor: function () {
      if (!pendingWrapper) return true;
      if (pendingColor) return true;
      if (window.ciwLaConfirmDialog && typeof window.ciwLaConfirmDialog.show === 'function') {
        window.ciwLaConfirmDialog.show({
          title: 'Choose a color',
          text: 'Pick a Transitions color before you continue.',
          primaryLabel: 'OK',
          hideSecondary: true
        });
      } else {
        window.alert('Choose a color');
      }
      return false;
    },
    getStepTitle: function () {
      return STEP_TITLE;
    }
  };

  [
    'DOMContentLoaded',
    'LensAdvizor:selectLensModal:open',
    'LensAdvizor:lens:rendered',
    'LensAdvizor:lensOptions:rendered',
    'LensAdvizor:prescriptionTypes:rendered'
  ].forEach(function (eventName) {
    document.addEventListener(eventName, scheduleScan);
  });

  document.addEventListener('LensAdvizor:lensOptions:rendered', handleLensOptionsRenderedDuringFlow);

  window.addEventListener('click', onMobileDrawerDismiss, true);

  document.addEventListener(
    'pointerdown',
    function (event) {
      var progCard = event.target.closest('.ciw-la-progressive-type-options-step .la-label-btn');
      if (progCard && isProgressiveTransitionsFlow()) {
        prepProgressiveTypeToPackageTransition();
      }
    },
    true
  );

  document.addEventListener(
    'pointerdown',
    function (event) {
      var back = event.target.closest('.ciw-la-gusa-back-btn, .la-steeper-back');
      if (!back || back.disabled) return;
      if (document.body.classList.contains(BODY_CLASS)) return;
      if (shouldArmSkipOnBackPointerdown()) {
        armSkipNativeColorStep();
      }
    },
    true
  );

  document.addEventListener(
    'click',
    function (event) {
      var back = event.target.closest('.ciw-la-gusa-back-btn, .la-steeper-back');
      if (!back || back.disabled) return;

      if (document.body.classList.contains(BODY_CLASS)) {
        if (isMobileViewport()) {
          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();
          dismissDrawerWithAnimation();
          return;
        }
        resetDrawerSelection();
        armSkipNativeColorStep();
        [0, 80, 180, 350, 650].forEach(function (delay) {
          window.setTimeout(skipIntermediateBack, delay);
        });
        return;
      }

      if (shouldReopenDrawerOnBack()) {
        if (programmaticBackNavigation || skippingBack) return;
        if (isProgressiveTypeStepActive()) {
          tagProgressiveTypeScopeIfNeeded();
          if (findTransitionDrawerRoot() && reopenDrawerFromForwardBack()) {
            event.preventDefault();
            event.stopPropagation();
            event.stopImmediatePropagation();
            return;
          }
        }
        if (isNativeColorStepActive()) {
          armSkipNativeColorStep();
          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();
          hideNativeColorStep();
          if (findTransitionDrawerRoot() && reopenDrawerFromForwardBack()) return;
          skipIntermediateBack();
          return;
        }
        if (/choose lens package/i.test(getActiveStepTitle())) {
          landOnDownstreamStepAfterBack();
          return;
        }
        if (/review your selection|available upgrade/i.test(getActiveStepTitle())) {
          landOnDownstreamStepAfterBack();
          return;
        }
        if (/lens thickness|lens index/i.test(getActiveStepTitle())) {
          queueResumeDrawerFromPackageBack();
        }
      }
    },
    true
  );

  document.addEventListener('LensAdvizor:selectLensModal:close', function () {
    resetDrawerSelection();
    deactivate();
    document.querySelectorAll('.ciw-la-transitions-drawer-step').forEach(function (el) {
      delete el.dataset.ciwSheetEntered;
    });
  });

  var modal = document.getElementById('lensadvizor-prescription-modal');
  if (modal) {
    new MutationObserver(scheduleScanFromMutation).observe(modal, { childList: true, subtree: true });
  }
})();
